import { Entity, UserEntityV1alpha1 } from '@backstage/catalog-model';

export const SERVICE_ACCOUNT_FLAG_KEY = 'isServiceAccount';

export type ServiceAccountEntity = UserEntityV1alpha1 & {
  spec: UserEntityV1alpha1['spec'] & {
    [K in typeof SERVICE_ACCOUNT_FLAG_KEY]: true;
  };
};

export const isServiceAccountEntity = (
  entity: Entity,
): entity is ServiceAccountEntity => {
  return Boolean(entity.spec?.[SERVICE_ACCOUNT_FLAG_KEY]);
};

export type ServiceAccountWatchEvent =
  | {
      status: 'timeout';
    }
  | {
      status: 'not-found';
    }
  | {
      status: 'found';
      value: ServiceAccountEntity;
    }
  | {
      status: 'invalid-entity';
    };
